import { render, staticRenderFns } from "./CornealDonationHome.vue?vue&type=template&id=b4b87e34&scoped=true"
import script from "./CornealDonationHome.vue?vue&type=script&lang=js"
export * from "./CornealDonationHome.vue?vue&type=script&lang=js"
import style0 from "./CornealDonationHome.vue?vue&type=style&index=0&id=b4b87e34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b87e34",
  null
  
)

export default component.exports